import { render } from "./SurveyComments.vue?vue&type=template&id=6d32d54f&scoped=true"
import script from "./SurveyComments.vue?vue&type=script&lang=js"
export * from "./SurveyComments.vue?vue&type=script&lang=js"

import "./SurveyComments.vue?vue&type=style&index=0&id=6d32d54f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d32d54f"]])

export default __exports__